import * as React from "react";
import { connect } from "react-redux";
import MyProfile from "../../screens/MyProfile";

import {
  fetchDistributorProfile,
  Distributorprof,
  EditDistributorprof,
  fetchStates,
  fetchDistrictById,
  fetchBank
} from "./action";
class MyProfileContainer extends React.Component<Props, State> {
  render() {
    return (
      <MyProfile
        fetchDistributorProfile={this.props.fetchDistributorProfile}
        DistributorprofDtls={this.props.DistributorprofDtls}
        Distributorprof={this.props.Distributorprof}
        EditDistributorprof={this.props.EditDistributorprof}
        fetchStates={this.props.fetchStates}
        statesList={this.props.statesList}
        fetchDistrictById={this.props.fetchDistrictById}
        districtById={this.props.districtById}
        fetchBank={this.props.fetchBank}
        banks={this.props.banks}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchDistributorProfile: value => {
      dispatch(fetchDistributorProfile(value));
    },
    EditDistributorprof: value => {
      dispatch(EditDistributorprof(value));
    },
    fetchStates: () => {
      dispatch(fetchStates());
    },
    fetchBank: () => {
      // console.log(" fetchBank: value ********");
      dispatch(fetchBank());
    },
    fetchDistrictById: value => {
      dispatch(fetchDistrictById(value));
    },
    Distributorprof: () => {}
  };
}
const mapStateToProps = state => {
  return {
    DistributorprofDtls: state.MyProfileReducer.DistributorprofDtls,
    statesList: state.MyProfileReducer.statesList,
    districtById: state.MyProfileReducer.districtById,
    banks: state.MyProfileReducer.banks
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(MyProfileContainer);
